module.exports = __webpack_public_path__ + "img/puja.2bd26121.svg";